import { Article, HelpCenterSection } from '../../models';

export function getArticleForSection(items: Article[], section: HelpCenterSection): Article[] {
  return items.filter((item) => item.pages.split(/\s*[\s,]\s*/).includes(section));
}
